import { Col, Row } from '@packages/utils';
import { useTheme } from 'styled-components';
import { ParagraphEllipsis } from 'components/Shared/ParagraphEllipsis';
import { EIconNames, Icon } from 'components/Base/Icon';
import { SLinkItemWrapper } from './LinkItem.styles';
import { TLinkItemProps } from './LinkItem.types';
import RemoveResource from '../../components/RemoveResource';

const LinkItem = ({ data, elcId, isResourceEditable }: TLinkItemProps) => {
  const theme = useTheme();
  const { resourceId, file, elcs, isGlobal } = data;
  // For non-global resources, use the elcId from the resource data
  // For global resources, keep elcId undefined so backend deletes from all ELCs
  const effectiveElcId = elcId || (!isGlobal ? elcs?.[0]?.elcId : undefined);

  return (
    <SLinkItemWrapper data-cy="link-item">
      <Row align="middle" wrap={false}>
        <Col className="mr-1">
          <Icon icon={EIconNames.LINK} color={theme.colorPrimaryDefault} />
        </Col>
        <Col>
          <a
            target="_blank"
            style={{ color: theme.colorBlackDescription }}
            href={file.url}
            rel="noreferrer"
            data-cy="resource-link"
          >
            <ParagraphEllipsis text={file.name} textMaxLength={20} />
            {/*  */}
          </a>
        </Col>
        {isResourceEditable && (
          <RemoveResource
            elcId={effectiveElcId}
            resourceId={resourceId}
            iconName={EIconNames.CLOSE}
            iconSize={16}
            className="ml-1"
          />
        )}
      </Row>
    </SLinkItemWrapper>
  );
};

export default LinkItem;
